import { render, staticRenderFns } from "./ItemColumn.vue?vue&type=template&id=cb5a6c96&"
import script from "./ItemColumn.vue?vue&type=script&lang=js&"
export * from "./ItemColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gantt-elastic/gantt-elastic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb5a6c96')) {
      api.createRecord('cb5a6c96', component.options)
    } else {
      api.reload('cb5a6c96', component.options)
    }
    module.hot.accept("./ItemColumn.vue?vue&type=template&id=cb5a6c96&", function () {
      api.rerender('cb5a6c96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskList/ItemColumn.vue"
export default component.exports